var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"h-flex h-flex-center h-height-100p"},[(_vm.loading)?_c('FwSpinLoader',{staticClass:"h-flex-center loader",attrs:{"colors":["#27dbbd", "#27DBBD", "#27DBBD"],"isActive":_vm.loading,"className":"h-p-20"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }